import React from "react";
import "@/App.css";
import { LanguageProvider } from './context/LanguageContext';
import Header from './components/Header';
import Hero from './components/Hero';
import About from './components/About';
import Services from './components/Services';
import WhyChoose from './components/WhyChoose';
import HowItWorks from './components/HowItWorks';
import Vision from './components/Vision';
import TransactionRequest from './components/TransactionRequest';
import Contact from './components/Contact';
import { Toaster } from './components/ui/sonner';
import Footer from './components/Footer';

function App() {
  return (
    <LanguageProvider>
      <div className="App">
        <Header />
        <Hero />
        <About />
        <Services />
        <WhyChoose />
        <HowItWorks />
        <Vision />
        <TransactionRequest />
        <Contact />
        <Footer />
        <Toaster position="bottom-right" richColors />
      </div>
    </LanguageProvider>
  );
}

export default App;
